/**
 * Filter Helpers for CardBody Component
 * Contains functions for filtering client and tag data
 */

/**
 * Filter client data based on search filter and project status
 * @param {Array} clientData - Array of client objects
 * @param {string} filter - Search filter string
 * @param {string} projectStatusFilter - Project status filter ("All", "Active", "Inactive")
 * @returns {Array} Filtered and sorted client data
 */
export const filterClientData = (clientData, filter, projectStatusFilter) => {
  return clientData
    .filter((client) => {
      const clientMatches = client.client_name
        .toLowerCase()
        .includes(filter.toLowerCase());

      const filteredProjects = client.projects.filter(
        (project) =>
          project.project_name
            .toLowerCase()
            .includes(filter.toLowerCase()) &&
          (projectStatusFilter === "All"
            ? true
            : projectStatusFilter === "Active"
              ? project.is_active === true
              : project.is_active === false)
      );

      return filteredProjects.length > 0;
    })
    .sort((a, b) => a.client_name.localeCompare(b.client_name));
};

/**
 * Filter tag items based on search query
 * @param {Array} tagOptions - Array of tag objects
 * @param {string} tagQuery - Search query string
 * @returns {Array} Filtered and sorted tag items
 */
export const filterTagItems = (tagOptions, tagQuery) => {
  const seen = new Set();
  return tagOptions
    .filter((item) => {
      if (!item.tag_name) return false;
      if (seen.has(item.tag_name.toLowerCase())) return false;
      seen.add(item.tag_name.toLowerCase());
      return item.tag_name.toLowerCase().includes(tagQuery.toLowerCase());
    })
    .sort((a, b) => a.tag_name.localeCompare(b.tag_name));
};
